// Lot 6 — « À regarder en premier » : répétitions repérées par des règles
// fixes, chacune avec sa règle. Jamais une décision ni une recommandation.

import { aRegarderEnPremier } from './services/suiviRessenti';

export default function ARegarderEnPremier({ donnees = null, depuis = null }) {
  if (!donnees?.ok || donnees.trouvee === false) return null;
  // Règles appliquées sur la période réellement chargée.
  const items = aRegarderEnPremier({
    feedbacks: donnees.feedbacks, jours: donnees.jours, depuis: donnees.debutCharge || depuis, trouvee: true,
  });
  return (
    <section className="jrn-block suivi-a-regarder">
      <div className="jrn-block__head">
        <h3 className="jrn-block__title">À regarder en premier</h3>
      </div>
      <p className="jrn-block__intro">Des répétitions repérées par des règles fixes. Aucune interprétation.</p>
      {items.length === 0 ? (
        <p>Rien de répété à signaler.</p>
      ) : (
        <ul>
          {items.map((item) => (
            <li key={item.cle}>
              {item.texte}
              <br />
              <span className="jrn-meta-chip">Règle : {item.regle}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
